import { FrontendEnvironment as e, BackendEnvironment as d } from "../../_types/misc/environments.mjs";
const o = "-dev.autohaus-digital.de", l = "-next.autohaus-digital.de", h = "-pre-release.autohaus-digital.de", r = "-test.autohaus-digital.de", i = "-live.autohaus-digital.de", n = (t, a) => t === e.LOCALSERVER ? `http://localhost:${a}` : `https://web${t === e.DEV ? "-dev" : t === e.NEXT ? "-next" : t === e["PRE-PRELEASE"] ? "-pre-release" : t === e.TEST ? "-test" : ""}.autohaus-digital.de`, E = (t, a) => t === d.LOCALSERVER ? `http://localhost:${a}` : `https://web-servlets${t === d.DEV ? "-dev" : t === d.NEXT ? "-next" : ""}.autohaus-digital.de`;
export {
  E as ahdWebBackendUrl,
  o as ahdWebDevUrl,
  n as ahdWebFrontendUrl,
  i as ahdWebLiveUrl,
  l as ahdWebNextUrl,
  h as ahdWebPreReleaseUrl,
  r as ahdWebTestUrl
};
